module.exports = __webpack_public_path__ + "static/media/Gilroy-Thin.437d0d08.ttf";